import React from "react";

export default function KYCGraphics() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="311"
      height="209"
      viewBox="0 0 311 209"
      fill="none"
    >
      <g clipPath="url(#msbk09tfma)">
        <path
          d="M311 111.049c0 42.072-26.681 77.919-64.053 91.56a96.525 96.525 0 0 1-17.527 4.598 98.216 98.216 0 0 1-48.966-4.445c-37.608-13.528-64.484-49.496-64.466-91.734 0-53.799 43.656-97.43 97.506-97.43a97.118 97.118 0 0 1 56.734 18.19C294.914 49.467 311 78.38 311 111.05z"
          fill="#E5E5E5"
        />
        <path
          d="M246.947 202.609a96.525 96.525 0 0 1-17.527 4.598 98.227 98.227 0 0 1-48.966-4.445l4.503-18.058.272-1.084 9.189.036 46.165.165.591 1.746 5.773 17.042z"
          fill="#2F2E41"
        />
        <path d="M85.196.5H.5v95.784h84.697V.5z" fill="#E5E9EB" />
        <path d="M83.538 2.526H2.008v91.732h81.53V2.526z" fill="#fff" />
        <path
          d="M42.847 90.996a4.569 4.569 0 0 0 4.57-4.567 4.569 4.569 0 0 0-4.57-4.568 4.569 4.569 0 0 0-4.57 4.568 4.569 4.569 0 0 0 4.57 4.567zM42.075 34.998H15.826v2.683h26.25v-2.683z"
          fill="#E5E9EB"
        />
        <path d="M55.443 43.04H15.826v2.683h39.617V43.04z" fill="#FC4C4C" />
        <path d="M51.554 51.132H15.826v2.684h35.728v-2.684z" fill="#E5E9EB" />
        <path d="M70.998 59.01H15.826v2.685h55.172V59.01z" fill="#FC4C4C" />
        <path d="M61.364 66.514H16.4v2.684h44.964v-2.684z" fill="#E5E9EB" />
        <path
          d="M120.936 156.36c.322.331.618.686.884 1.063l41.398-1.012 4.83-8.82 14.271 5.544-7.032 16.445a6.687 6.687 0 0 1-6.944 4.005l-46.773-5.647a8.767 8.767 0 0 1-15.63-4.951 8.753 8.753 0 0 1 5.206-8.491 8.764 8.764 0 0 1 9.789 1.862l.001.002z"
          fill="#FEDBDB"
        />
        <path
          d="m176.656 105.996 19.374-6.346 5.691-7.8 27.69 1.638 4.066 9.102 14.765 6.973-2.269 42.117-3.882 39.417c-19.962-10.331-57.215-2.455-57.542-2.326l-7.893-82.775z"
          fill="#FC4C4C"
        />
        <path
          d="m180.798 163.004-19.706-7.88.084-.35c.084-.354 8.472-35.383 9.585-41.012 1.16-5.864 5.399-7.486 5.579-7.552l.131-.048 7.799 2.372 3.425 26.897-6.897 27.573z"
          fill="#FC4C4C"
        />
        <path
          d="M223.348 189.364c.462-.011.924.015 1.382.077l27.404-31.029-3.188-9.534 13.772-6.689 7.285 16.334a6.68 6.68 0 0 1-1.783 7.812l-35.945 30.438a8.759 8.759 0 0 1-9.434 10.074 8.767 8.767 0 0 1-7.666-6.362 8.757 8.757 0 0 1 3.24-9.417 8.779 8.779 0 0 1 4.933-1.704z"
          fill="#FEDBDB"
        />
        <path
          d="m249.946 161.433-11.431-26.875 4.459-18.72 4.804-6.066a2.766 2.766 0 0 1 2.223.021c1.773.712 3.28 2.897 4.484 6.492l10.714 30.499-15.253 14.649z"
          fill="#FC4C4C"
        />
        <path
          d="M190.636 81.892V61.631a27.158 27.158 0 0 1 7.893-19.224 27.16 27.16 0 0 1 19.182-8.016 27.178 27.178 0 0 1 19.235 7.889 27.146 27.146 0 0 1 8.02 19.351v20.261a3.652 3.652 0 0 1-3.649 3.647h-47.032a3.654 3.654 0 0 1-3.649-3.647z"
          fill="#2F2E41"
        />
        <path
          d="M212.219 85.067c11 0 19.917-8.912 19.917-19.905 0-10.994-8.917-19.905-19.917-19.905-10.999 0-19.916 8.912-19.916 19.905s8.917 19.905 19.916 19.905z"
          fill="#FEDBDB"
        />
        <path
          d="M184.21 63.252a21.491 21.491 0 0 1 6.301-15.18 21.52 21.52 0 0 1 15.188-6.297h4.055a21.517 21.517 0 0 1 15.187 6.298 21.491 21.491 0 0 1 6.301 15.179v.405h-8.569l-2.922-8.18-.584 8.18h-4.428l-1.475-4.126-.295 4.126H184.21v-.405z"
          fill="#2F2E41"
        />
        <path
          d="M210.259 87.818a3.594 3.594 0 0 1-.285-3.815c4.296-8.168 10.312-23.26 2.327-32.568l-.572-.668h23.181v34.785l-21.058 3.713a3.638 3.638 0 0 1-3.591-1.447h-.002z"
          fill="#2F2E41"
        />
        <path
          d="M42.774 7.96a9.722 9.722 0 0 0-8.98 5.996 9.707 9.707 0 0 0 2.107 10.585 9.72 9.72 0 0 0 16.59-6.867v-.001a9.708 9.708 0 0 0-5.999-8.974 9.723 9.723 0 0 0-3.719-.739zm0 2.914a2.917 2.917 0 0 1 2.86 3.482 2.913 2.913 0 0 1-3.976 2.123 2.914 2.914 0 0 1 1.116-5.605zm0 14.027a7.083 7.083 0 0 1-5.831-3.11c.047-1.942 3.887-3.012 5.83-3.012 1.944 0 5.785 1.07 5.832 3.012a7.09 7.09 0 0 1-5.831 3.11z"
          fill="#FC4C4C"
        />
        <path
          d="M42.887 88.18c4.003-7.333 13.594-11.977 21.44-7.791 3.532 1.884 6.339 5.216 7.23 9.154 1.034 4.576-1.145 8.938-3.394 12.782-1.221 2.086-2.56 4.13-3.57 6.331-1.046 2.279-1.794 4.912-1.006 7.392.71 2.233 2.487 3.857 4.434 5.051a33.017 33.017 0 0 0 6.814 3.042 40.114 40.114 0 0 0 15.213 1.967 41.65 41.65 0 0 0 7.582-1.225c2.642-.673 5.235-1.527 7.882-2.185 4.419-1.097 9.458-1.643 13.648.561 4.071 2.142 5.893 6.62 6.457 10.978 1.04 8.046-2.152 16.395-7.915 22.03-2.765 2.703-6.245 4.936-10.034 5.85-3.307.797-7.553.746-10.184-1.724-2.937-2.758-2.246-7.179.086-10.088 2.977-3.712 8.02-4.603 12.521-4.694 5.119-.102 10.234.659 15.35.186a23.582 23.582 0 0 0 7.259-1.75 18.41 18.41 0 0 0 5.471-3.7c3.159-3.067 5.289-7.153 6.348-11.401 1.276-5.109.998-10.478.008-15.61a70.411 70.411 0 0 0-2.036-7.828c-.342-1.083-2.054-.62-1.709.471 3.049 9.664 4.749 20.838-1.142 29.81a17.76 17.76 0 0 1-10.62 7.641c-5.099 1.266-10.45.64-15.634.452-4.929-.179-10.341.014-14.566 2.883-3.467 2.354-5.891 6.83-4.843 11.056 1.01 4.075 4.928 6.142 8.848 6.46 4.112.335 8.158-1.044 11.612-3.201 7.184-4.487 11.96-12.377 12.96-20.743.521-4.359-.009-9.054-1.987-13.011a12.746 12.746 0 0 0-4.683-5.215c-2.012-1.233-4.336-1.84-6.67-2.055-5.303-.488-10.399 1.332-15.43 2.724a42.787 42.787 0 0 1-7.867 1.501 39.333 39.333 0 0 1-7.763-.126 38.274 38.274 0 0 1-7.522-1.669 30.087 30.087 0 0 1-6.827-3.085c-1.887-1.206-3.519-2.933-3.611-5.286-.101-2.552 1.186-4.939 2.41-7.09 2.42-4.25 5.408-8.406 6.039-13.381.552-4.352-1.2-8.642-4.226-11.746a15.887 15.887 0 0 0-11.74-4.868c-4.49.129-8.788 2.08-12.09 5.076a19.892 19.892 0 0 0-4.078 5.177c-.547 1.001.984 1.896 1.531.894l.004.003z"
          fill="#3F3D56"
        />
      </g>
      <defs>
        <clipPath id="msbk09tfma">
          <path fill="#fff" transform="translate(.499 .5)" d="M0 0h310.501v208H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
